import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Attach JWT automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Auto login (get token)
export const initAuth = async () => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/auth/token`, {
      apiKey: process.env.REACT_APP_ADMIN_API_KEY,
    });

    localStorage.setItem("token", res.data.token);
    return res.data.token;
  } catch (err) {
    console.error("Auth failed", err);
  }
};

export default api;